export function init_password_new() {
// 二重送信防止
  $('form#password_form').submit(function() {
    $('.js-submit-password-form').prop('disabled', true);
  });
}